import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recycling',
  templateUrl: './recycling.component.html',
  styleUrls: ['./recycling.component.scss']
})
export class RecyclingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
